import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import * as Core from '../../core';
import SeasonCard from '../../components/seasonCard';
import withLoading, { WithLoadingProps } from '../../components/withLoading';
import { DOMAIN_SEASON, DOMAIN_SEASON_LOWER } from '../../constants/domainCopy';
import { useProfile } from '../../hooks/store';
import { SeasonService } from '../../services/seasonService';
import useCanJoinSeason from '../league/canJoinSeason';

interface SuggestedSeasonsProps extends WithLoadingProps {
    onJoinSeason: () => void;
}

const SuggestedSeasons = (props: SuggestedSeasonsProps) => {
    const { onJoinSeason, setError, setIsLoading } = props;

    const [seasons, setSeasons] = useState<Core.Models.Season[]>([]);

    const profile = useProfile();

    const { alreadyInSeason, canJoinSeason, canRegisterForSeason } = useCanJoinSeason();

    const load = useCallback(async () => {
        try {
            const response = await SeasonService.getSuggestedSeasons();
            setSeasons(response);
        } catch (e) {
            setError(e);
        } finally {
            setIsLoading(false);
        }
    }, [setError, setIsLoading]);

    const onJoinedSeason = useCallback(async () => {
        await load();
        onJoinSeason();
    }, [onJoinSeason, load]);

    useEffect(() => {
        (async () => {
            await load();
        })();
    }, [load]);

    return (
        <div className="suggested-seasons">
            <h2>
                Suggested <span className="theme__text__alternate">{DOMAIN_SEASON}s</span>
            </h2>
            {seasons.length === 0 ? (
                <p>
                    Looks like we don't have any suggested {DOMAIN_SEASON_LOWER}s to display. Go to your{' '}
                    <Link to={'/league'}>league home</Link> to discover upcoming {DOMAIN_SEASON_LOWER}s.
                </p>
            ) : (
                <div className="league-page__seasons__season-container">
                    {seasons.map((season: Core.Models.Season) => (
                        <SeasonCard
                            alreadyInSeason={alreadyInSeason(season) && !!profile?.organizationId}
                            canJoinSeason={canJoinSeason(season)}
                            canRegisterForSeason={canRegisterForSeason(season)}
                            key={season.id}
                            reloadDataOnJoin={onJoinedSeason}
                            season={season}
                            showImage
                            showSeasonOperator
                            showTimingDescription
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default withLoading(SuggestedSeasons, {
    loadingProps: { blockItem: true },
});
